import type { TableFilterBase } from '../TableFilter';
import { filterOperators } from '../operators';

type FilterFactory<TFilter extends TableFilterBase> = () => TFilter;

export const createDeviceFilter = <TFilter extends TableFilterBase>(
  baseFilterFactory: FilterFactory<TFilter>,
): TFilter => {
  const baseFilter = baseFilterFactory();
  return {
    ...baseFilter,
    operators: baseFilter.operators.filter((operator) =>
      filterOperators.color.some((colorOperator) => colorOperator !== operator),
    ),
  };
};
